import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { enterAllIntoCompetition } from "../../../../../api";
import useErrorAlert from "../../../../../hooks/useErrorAlert";
import useLocation from "../../../../../hooks/useLocation";
import getGenericErrorInfo from "../../../../../utils/getGenericErrorInfo";
import { useEntryAuthWall } from "../../hooks/useAuthWall";
import usePreparedCompetitors from "../../hooks/usePreparedCompetitors";

export default function useCompetitorListScreen() {
  const { competitionUUID } = useParams();

  useEntryAuthWall();

  const location = useLocation<{ isJudge: boolean }>();
  const isJudge = location.state?.isJudge;

  const [preparedCompetitors, setPreparedCompetitors] =
    usePreparedCompetitors(competitionUUID);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const { setError } = useErrorAlert();

  const onSubmit = async () => {
    if (!competitionUUID) {
      return;
    }
    setIsSubmitting(true);
    try {
      await enterAllIntoCompetition(competitionUUID, preparedCompetitors);
      if (isJudge) {
        navigate(`/${competitionUUID}/judge/onboarding/confirm`);
      } else {
        navigate(`/${competitionUUID}`);
      }
      setPreparedCompetitors([]);
    } catch (error) {
      setError(getGenericErrorInfo(error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return { competitors: preparedCompetitors, onSubmit, isSubmitting, isJudge };
}
